export const apiUsersRoute = "/organization/api-users";

export const createApiUserRoute = `/organization/create-api-user`;

export const editApiUserRouteOnTab1 = (apiUserId: string) =>
  `/organization/edit-api-user/${apiUserId}`;

export const editApiUserRouteOnTab2 = (apiUserId: string) =>
  `/organization/edit-api-user/${apiUserId}/application-roles`;

export const editApiUserNameRoute = (apiUserId: string) =>
  `/organization/api-user/${apiUserId}/edit-name`;

export const manageAppRolesRoute = (apiUserId: string) =>
  `/organization/api-user/${apiUserId}/manage-application-roles`;
